/*
 *
 * DropdownMenu
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Dropdown } from 'react-bootstrap';
import FaCog from 'react-icons/lib/fa/cog';
import styles from './styles.css';


const DropdownMenu = ({ children }) => (
  <ButtonToolbar>
    <Dropdown
      pullRight
      id="dropdown-menu" // react-bootstrap prints a console error if no id is provided.
      className={styles.buttonToolbarDropdown}
    >
      <Dropdown.Toggle noCaret>
        <FaCog />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {children}
      </Dropdown.Menu>
    </Dropdown>
  </ButtonToolbar>
);

DropdownMenu.propTypes = {
  children: PropTypes.any,
};

DropdownMenu.defaultProps = {
  children: null,
};

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/index.js